import { config } from '@rematter/config';
import {
  AccountSortOption,
  AccountType,
  enumAccountSortOption,
} from '@rematter/frontend-lib-api-client';
import { accountsQueryAtom } from '@rematter/modules/crm/_graphql/queryAccounts';

import { atomFromQueryString } from '~/shared/state';

// 🟣🟣🟣 PARAMS
export const $searchTerm = atomFromQueryString.string('q');
export const $offset = atomFromQueryString.number('offset', 0);
export const $limit = atomFromQueryString.number('limit', config.pageSize);
export const $sorting = atomFromQueryString.string<AccountSortOption>(
  'sorting',
  enumAccountSortOption.NameAsc,
);
export const $accountTypes =
  atomFromQueryString.stringSet<AccountType>('accountTypes');

// 🟢🟢🟢 REMOTE DATA
export const $accountList = accountsQueryAtom((get) => {
  const accountTypes = get($accountTypes);
  return {
    variables: {
      searchTerm: get($searchTerm),
      offset: get($offset),
      limit: get($limit),
      sorting: get($sorting),
      accountTypes:
        accountTypes.size > 0 ? Array.from(accountTypes) : undefined,
    },
  };
});
